import callApi from 'utils/api/callApi'
import { decamelizeKeysWithNumbers } from 'utils/api/decamelizeKeysWithNumbers'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'

export interface IQuickBooksAuthStoreRequest {
  code: string
  state: string
  realmId: string
}

export interface IGetQuickBooksGrantUrlResponse {
  grantUrl: string
}

interface IImportQuickBooksCustomerResponse {
  importJobQueued: boolean
}

interface ICreateQuickBooksInvoiceResponse {}

/**
 * Sends request with auth tokens received from QuickBooks redirect
 * @method POST
 */
export const exchangeAuthCodeStore = (body: IQuickBooksAuthStoreRequest): Promise<boolean> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.quickbooksAuth}/exchange_auth_code_store`,
    method: 'POST',
    body: decamelizeKeysWithNumbers(body),
  })
}

/**
 * Gets QuickBooks auth URL for current user
 * @method GET
 */
export const getQuickBooksGrantUrl = (): Promise<IGetQuickBooksGrantUrlResponse> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.quickbooksAuth}/grant_url`,
    method: 'GET',
  })
}

/**
 * Triggers final step of QuickBooks integration flow
 * @method POST
 * @note Although it's a post request, it doesn't take any params
 */
export const importQuickBooksCustomer = (): Promise<IImportQuickBooksCustomerResponse> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.quickbooks}/import_customers`,
    method: 'POST',
  })
}

/**
 * Create a new QuickBooks invoice
 * @method POST
 */
export const createQuickbooksInvoice = (
  shipmentId: string
): Promise<ICreateQuickBooksInvoiceResponse> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.quickbooks}/create_invoice`,
    method: 'POST',
    body: decamelizeKeysWithNumbers({
      id: shipmentId,
    }),
  })
}
